'use client';

import React, { useEffect, useState } from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from '@components/SVGIcon/Icons';
import cn from '../style.module.scss';

export type DefaultArrowProps = {
  size?: number;
  strokeWidth?: number;
  color?: string;
};

export type SplideArrowsProps = {
  splideRef: React.MutableRefObject<any>;
  arrowsClassName?: string;
  prevClassName?: string;
  nextClassName?: string;
  prevArrow?: React.ReactNode;
  nextArrow?: React.ReactNode;
  defaultArrowProps?: DefaultArrowProps;
};

export default function SplideArrows({
  splideRef,
  arrowsClassName = '',
  prevClassName = '',
  nextClassName = '',
  prevArrow,
  nextArrow,
  defaultArrowProps = {},
}: SplideArrowsProps) {
  const [prevDisabled, setPrevDisabled] = useState(false);
  const [nextDisabled, setNextDisabled] = useState(false);

  useEffect(() => {
    const splide = splideRef.current?.splide;
    if (!splide) return;

    const update = () => {
      const { index, length, options } = splide;
      if (options.type === 'loop') {
        setPrevDisabled(false);
        setNextDisabled(false);
      } else {
        setPrevDisabled(index === 0);
        setNextDisabled(index === length - 1);
      }
    };

    update();
    splide.on('mounted move updated', update);
    return () => splide.off('mounted move updated', update);
  }, [splideRef]);

  return (
    <ul className={`${cn.splideArrows} ${arrowsClassName}`}>
      <li>
        <button
          type="button"
          className={`${cn.arrowsElements} ${prevClassName}`}
          disabled={prevDisabled}
          onClick={() => splideRef.current?.splide?.go('<')}
        >
          {prevArrow ?? (
            <DefaultArrow direction="left" {...defaultArrowProps} />
          )}
        </button>
      </li>

      <li>
        <button
          type="button"
          className={`${cn.arrowsElements} ${nextClassName}`}
          disabled={nextDisabled}
          onClick={() => splideRef.current?.splide?.go('>')}
        >
          {nextArrow ?? (
            <DefaultArrow direction="right" {...defaultArrowProps} />
          )}
        </button>
      </li>
    </ul>
  );
}

function DefaultArrow({
  direction,
  size = 20,
  color = 'currentColor',
}: {
  direction: 'left' | 'right';
  size?: number;
  color?: string;
}) {
  return <>{direction === 'left' ? <ArrowLeftIcon /> : <ArrowRightIcon />}</>;
}
